import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  productTypes,
  getDataConfig,
} from './combineMorningstarfundsReducer.js'
import { generateUID } from '../../../../spa/utility/threatMetrix/TMX.js'
export default function Filters(props) {
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const {
    sortData,
    selectedDisplayMorningstarGroup,
    classOptions,
    selectedClass,
    isLoading,
    initialLoad,
  } = props

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen)
  }

  const uniqueId = generateUID()
  const onChangeDisplayMorningstarGroup = (event) => {
    sortData({
      selectedDisplayMorningstarGroup: event.currentTarget.checked,
      selectedGroups: [],
    })
  }

  const onClassDropdownChange = (product, value) => {
    const _selectedClass = selectedClass
    if (selectedClass[product]?.includes(value)) {
      _selectedClass[product] = selectedClass[product].filter(
        (i) => i !== value
      )
    } else {
      _selectedClass[product].push(value)
    }
    sortData({ selectedClass: _selectedClass })
    initialLoad()
  }

  const onClearFilter = () => {
    toggleFilter()
    sortData({
      selectedClass: {
        [productTypes.MF]: [],
        [productTypes.ETF]: [],
      },
      rowsData: [],
    })
  }

  const renderCol = (product) => {
    return (
      <div className="u-paddingHoriz7gu u-paddingTop4gu">
        <div className="u-textSizeMsrp1 u-textBold MutualFunds-filterTitle u-textColorBrandDark">
          {getDataConfig[product]?.productName}
        </div>
        <div>
          {classOptions[product]?.map((itm) => (
            <div key={itm} className="u-flex u-flexAlignItemsCenter">
              <div className="Checkbox">
                <input
                  type="checkbox"
                  id={`checkbox_${product}_${itm}`}
                  data-qa-automation={`checkbox_${product}_${itm}`}
                  className="Checkbox-button u-posRelative"
                  data-analytics={`${product}_filter-checkbox`}
                  checked={selectedClass[product]?.includes(itm)}
                  value={itm}
                  onChange={() => onClassDropdownChange(product, itm)}
                />
                <label
                  htmlFor={`checkbox_${product}_${itm}`}
                  className="Checkbox-label u-margin0"
                >
                  <div className="u-textNoWrap">{itm}</div>
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const getFilterCount = () => {
    return Object.keys(selectedClass).reduce(
      (p, n) => p + selectedClass[n]?.length,
      0
    )
  }

  return (
    <div className="u-lg-flex u-md-flex u-paddingTop3gu">
      {!isLoading && (
        <>
          <div className="u-lg-flexGrow1 u-md-flexGrow1 u-paddingBottom3gu">
            <div className="u-bgColorLight">
              <button
                onClick={toggleFilter}
                className="Button Button-filter u-paddingVert1gu u-paddingHoriz4gu u-posRelative u-sizeFull"
                data-analytics="simple-entry-component-body-filter-dropdown-btn"
                data-qa-automation="filter-dropdown-btn"
              >
                <div className="u-flex u-flexAlignItemsCenter ">
                  <span className="u-textSizeMsrp5 MutualFunds-filterButton arrow Icon--material u-textSizeMsrp2">
                    {isFilterOpen ? 'expand_less' : 'expand_more'}
                  </span>
                  <h2 className="u-textSizeMsrp1 u-paddingLeft3gu u-textBold u-textColorBrandDark">
                    Filters
                  </h2>
                  <div
                    className="u-textSizeMsrp1 u-marginLeft2gu"
                    data-qa-automation="filter-applied-count"
                  >
                    ({getFilterCount()} applied)
                  </div>
                </div>
              </button>
              {isFilterOpen && (
                <div className="u-posRelative">
                  <div
                    className="u-boxShadow2 u-bgColorLight u-sizeFull u-posAbsolute"
                    style={{ zIndex: 352 }}
                  >
                    <div className="u-lg-flex u-md-flex u-paddingVert1gu">
                      {renderCol(productTypes.MF)}
                      {renderCol(productTypes.ETF)}
                    </div>
                    <div className="u-paddingVert4gu u-paddingHoriz7gu">
                      <button
                        className="Button Button--primary Button--small"
                        data-tracking="view-results"
                        data-qa-automation="viewResults"
                        onClick={toggleFilter}
                      >
                        View Results
                      </button>
                      <button
                        className="Button Button--tertiary Button--small u-marginLeft3gu"
                        data-tracking="clear-filters"
                        data-qa-automation="clearFilters"
                        onClick={onClearFilter}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="u-lg-flexGrow1 u-md-flexGrow1 u-flexInline u-flexJustifyEnd">
            <div className="Checkbox u-paddingBottom5gu u-cursor">
              <input
                type="checkbox"
                id={`morningstarGroupCheckbox_${uniqueId}`}
                className="u-hidden Checkbox-button"
                checked={selectedDisplayMorningstarGroup}
                onChange={onChangeDisplayMorningstarGroup}
              />
              <label
                htmlFor={`morningstarGroupCheckbox_${uniqueId}`}
                className="Checkbox-label u-textNoWrap"
              >
                Group by Morningstar Category
              </label>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

Filters.propTypes = {
  sortData: PropTypes.func,
  selectedDisplayMorningstarGroup: PropTypes.bool,
  isLoading: PropTypes.bool,
  selectedClass: PropTypes.object,
  classOptions: PropTypes.object,
  initialLoad: PropTypes.func,
}
